import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { KMCDepartmentLeftManu } from "../components/KMCDepartmentLeftManu";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { KMCBudgetList } from "../utils/constants";

const KMCBudget = () => {
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> About Us - KMC Budget </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <KMCDepartmentLeftManu />
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title">
                    <h3 className="fontSizeClass"> KMC Budget </h3>
                  </div>
                  <div className="mayor-table2">
                    <table className="table table-bordered">
                      <thead>
                        <tr className="table-warning table-bor-2">
                          <th colSpan={2} scope="col">
                            KMC Budget
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {KMCBudgetList.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {item.leftBudgetStatement.fileStoreId ? (
                                <DownloadFileByFileStoreId
                                  fileStoreId={
                                    item.leftBudgetStatement.fileStoreId
                                  }
                                  label={item.leftBudgetStatement.name}
                                  classAdd={false}
                                />
                              ) : (
                                <span>{item.leftBudgetStatement.name}</span>
                              )}
                            </td>
                            <td>
                              {item.rightBudgetStatement.fileStoreId ? (
                                <DownloadFileByFileStoreId
                                  fileStoreId={
                                    item.rightBudgetStatement.fileStoreId
                                  }
                                  label={item.rightBudgetStatement.name}
                                  classAdd={false}
                                />
                              ) : (
                                <span>{item.rightBudgetStatement.name}</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMCBudget;
